import { useMemo } from "react";
import { useAppSelector } from "../app/hooks";
import {
  useGetCustomerQuery,
  useGetCustomerConditionQuery,
} from "../features/customer/customerApi";
import { selectCustomer } from "../features/customer/customerSlice";
import { customerKindEnum, customerTypeEnum } from "../utils";

enum CustomerCondition {
  Standart = "Standart",
  Vip = "Vip",
  Eforcement = "İcralik",
}

const getCustomerName = (customer: any) => {
  const { name, surname, commercialTitle, usedName, customerKindId } = customer;

  switch (customerKindId) {
    case customerKindEnum.indivual:
      return `${name} ${surname}`;
    case customerKindEnum.corporate:
      return commercialTitle;
    default:
      return `${commercialTitle} - ${usedName}`;
  }
};

const useCustomer = (customerId: string | undefined = undefined) => {
  // if customer id provided then get customer request
  // after the req successfully customer state automatically updated
  useGetCustomerQuery(customerId, {
    skip: !Boolean(customerId),
  });

  // get customer state from store
  const customer = useAppSelector(selectCustomer);

  // if customer id provided then get customer status request
  // const { data: customerStatus } = useGetCustomerStatusQuery(
  //   customer?.customerDetail?.statusId,
  //   {
  //     skip: !Boolean(customer),
  //   }
  // );
  const { data: customerCondition } = useGetCustomerConditionQuery(
    customer?.customerDetail?.conditionId,
    {
      skip: !Boolean(customer?.customerDetail?.conditionId),
    }
  );
  const isRealCustomer = customer?.customerTypeId === customerTypeEnum.real;

  const isVipCustomer = customerCondition?.data.name === CustomerCondition.Vip;

  const isActive = customer?.customerDetail?.isActive;

  const customerName = getCustomerName(customer);

  const ownerFullName = customer?.ownerFullName || "";

  const mhnNumber = customer?.customerDetail?.mhnNumber || "";

  const isBlueCardCitizen = customer?.customerDetail?.isBlueCardCitizen;

  const accountLogoCode = customer?.logoInfo?.companyAccountCode || "";

  const supplierLogoCode = customer?.logoInfo?.supplierAccountCode || "";

  const customerCode = customer?.customerDetail?.customerCode || "";

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(
    () => ({
      customer,
      customerName,
      isRealCustomer,
      isVipCustomer,
      isActive,
      ownerFullName,
      mhnNumber,
      isBlueCardCitizen,
      accountLogoCode,
      supplierLogoCode,
      customerCode,
    }),
    [
      customer,
      customerName,
      isRealCustomer,
      isVipCustomer,
      isActive,
      ownerFullName,
      mhnNumber,
      isBlueCardCitizen,
      accountLogoCode,
      supplierLogoCode,
      customerCode,
    ]
  );
};

export default useCustomer;
